
import { ACLEntityTypeDto } from './aclEntityType.dto';
import { BaseDto } from './base.dto';

export enum ACLFieldType{
    OTHER_BINARY_JSON = 0,
    TEXT,
    INTEGER,
    DOUBLE_CURRENCY_FLOAT,
    BOOLEAN,
    RELATIONSHIP
}

export class ACLEntityTypeFieldDto extends BaseDto{  
    entityType: ACLEntityTypeDto;
    dbName: string;
    fullName: string;
    fieldType: ACLFieldType;
    fieldTypeMeta?: string;
    allowValueOverride?: boolean;
    
}